// Base Paths
export const basePaths = {
  home: "/",
  login: "/login",
  note: "/note",
  search: "/search",
  new: "/new",
};

// Params
export const params = {
  searchTerm: "term",
  redirect: "redirect",
  showHighlights: "showHighlights",
  sortBy: "sortBy",
};

// Other
export const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const searchSortOptions = { score: 0, title: 1, lastModified: 2 };

export const authTypes = { none: "none", password: "password", totp: "totp" };
